/**
 * Strings for global search, the command palette (components/ui/CommandPalette.tsx).
 * Spread into the main catalog; `SEARCH_EN` is typed against `SEARCH_ES`, so a
 * missing English string fails to compile.
 */

export const SEARCH_ES = {
  'search.label': 'Buscar',
  'search.placeholder': 'Busca en notas, tarjetas y mazos…',
  'search.results': 'Resultados',
  'search.close': 'Cerrar',
  'search.group.actions': 'Acciones',
  'search.group.decks': 'Mazos',
  'search.group.notes': 'Notas',
  'search.group.cards': 'Tarjetas',
  'search.group.count': '{shown} de {total}',
  'search.indexing': 'Buscando también dentro de notas y tarjetas…',
  'search.noResults': 'Nada coincide con «{query}»',
  'search.hint.navigate': 'moverte',
  'search.hint.open': 'abrir',
} as const

export const SEARCH_EN: Record<keyof typeof SEARCH_ES, string> = {
  'search.label': 'Search',
  'search.placeholder': 'Search notes, cards and decks…',
  'search.results': 'Results',
  'search.close': 'Close',
  'search.group.actions': 'Actions',
  'search.group.decks': 'Decks',
  'search.group.notes': 'Notes',
  'search.group.cards': 'Cards',
  'search.group.count': '{shown} of {total}',
  'search.indexing': 'Also searching inside notes and cards…',
  'search.noResults': 'Nothing matches “{query}”',
  'search.hint.navigate': 'move',
  'search.hint.open': 'open',
}
